module.exports = __webpack_public_path__ + "img/TG.d6464ea4.png";